import { Cycle } from '../../../store/models/cycles';

const matchName = (name: string | undefined, query: string): boolean => {
  if (!name) return false;
  return name.toLowerCase().includes(query.toLowerCase());
};

const matchReportId = (reportId: number | string | undefined, query: string): boolean => {
  if (!reportId) return false;
  const formattedReportId = reportId.toString().padStart(6, '0');
  return query.startsWith('0')
    ? formattedReportId.toLowerCase().startsWith(query.toLowerCase())
    : formattedReportId.toLowerCase().includes(query.toLowerCase());
};

export const filterCyclesBySearchQuery = (cycles: Cycle[], query: string): Cycle[] => {
  const filteredCycles = cycles.filter((cycle) => {
    const nameMatch = matchName(cycle.name, query);
    const reportIdMatch = matchReportId(cycle.report_id, query);

    return nameMatch || reportIdMatch;
  });

  return filteredCycles;
};
